'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _input = require('./input');

var _input2 = _interopRequireDefault(_input);

var _baseForm = require('./base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonTextSubmit = _baseForm2['default'].createFormClass({

    displayName: 'ButtonTextSubmit',

    propTypes: {
        'actionButton': _react2['default'].PropTypes.element.isRequired,
        'initialValue': _react2['default'].PropTypes.string,
        'textPlaceholder': _react2['default'].PropTypes.string,
        'textClass': _react2['default'].PropTypes.string,
        'inputName': _react2['default'].PropTypes.string,
        'additionalFormData': _react2['default'].PropTypes.object,
        'validate': _react2['default'].PropTypes.func,
        'initialErrorMessage': _react2['default'].PropTypes.string,
        'errorClass': _react2['default'].PropTypes.string,
        'divClass': _react2['default'].PropTypes.string,
        'url': _react2['default'].PropTypes.string.isRequired,
        'formName': _react2['default'].PropTypes.string.isRequired,
        'initiallyShowField': _react2['default'].PropTypes.bool,
        'tabOffset': _react2['default'].PropTypes.number
    },

    onSubmit: function onSubmit(evt) {
        // always validate before acting
        evt.preventDefault();
        var isValid = this.doValidation();
        if (!isValid) {
            return false;
        }

        this.setState({
            'isSending': true,
            'inputError': false
        });

        if (this.props.additionalFormData) {
            for (var key in this.props.additionalFormData) {
                var input = $('<input>').attr('type', 'hidden').attr('name', key).val(this.props.additionalFormData[key]);
                $(document.forms[name = this.props.formName]).append($(input));
            }
        }

        document.forms[name = this.props.formName].submit();

        return false;
    },

    getInitialState: function getInitialState() {
        return {
            isSending: false,
            inputError: false,
            errorMessage: this.props.initialErrorMessage
        };
    },

    handleKeyDown: function handleKeyDown(evt) {
        this.setState({ inputError: false, errorMessage: null });
        if (evt.keyCode == 13) {
            return this.onSubmit();
        }
    },

    handleTextInput: function handleTextInput(value, evt) {
        this.setState({ text: value.trim() });
    },

    handleOnBlur: function handleOnBlur(evt) {
        if (typeof this.state.text !== 'undefined') {
            this.doValidation();
        }
    },

    doValidation: function doValidation() {
        //FIXME: should probably move validation down into the Input component
        if (this.props.validate) {
            var inputError = this.props.validate(this.state.text);
            if (inputError) {
                this.setState({ inputError: inputError !== false, errorMessage: inputError });
                return false;
            }
        }
        return true;
    },

    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);

        var divClasses = {
            'm-button-submit': true,
            'is-active': true
        };
        divClasses[this.props.divClass] = true;
        var standardInput = _react2['default'].createElement(_input2['default'], {
            ref: 'textEntry',
            inputName: this.props.inputName,
            handleChange: this.handleTextInput,
            className: this.props.textClass,
            defaultValue: this.props.initialValue,
            placeholder: this.props.textPlaceholder,
            onBlur: this.handleOnBlur,
            onKeyDown: this.handleKeyDown,
            disabled: this.state.isSending,
            error: this.state.inputError,
            errorClass: this.props.errorClass,
            errorMessage: this.state.errorMessage,
            tabIndex: tabOffset });

        divClasses = (0, _classnames2['default'])(divClasses);

        var newBtnProps = {
            'onClick': this.onSubmit,
            'disabled': this.state.isSending
        };
        if (this.state.isSending) {
            newBtnProps.buttonText = 'Sending';
        }
        var btn = _react2['default'].cloneElement(this.props.actionButton, newBtnProps);

        return _jsx('form', {
            name: this.props.formName,
            method: 'POST',
            action: this.props.url
        }, void 0, _jsx('div', {
            className: divClasses
        }, void 0, this.renderCsrfField(), standardInput, btn, this.props.children));
    }
});
module.exports = ButtonTextSubmit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/button-text-submit.jsx
 ** module id = 608
 ** module chunks = 0
 **/